<template>
    <div class="w-100 text-center p-5 d-print-none">
        <button class="btn btn-primary" @click="askPrint">
            <i class="bi bi-filetype-pdf me-1"></i>
            Enregistrer en PDF ou imprimer
        </button>
    </div>

    <div class="A4 d-flex">

        <div style="width:6.5cm;" class="sidebar bg-primary d-flex flex-column">

            <img src="@/assets/images/avatar.jpg" :alt="datas.about.title" class="rounded-circle border-3 border" style="width:4cm;margin-top:1.25cm;margin-left:1.25cm;margin-right:1.25cm;">

            <div style="padding-left:0.5cm;padding-right:0.5cm;" class="flex-grow-1" >


                <h3>Contact</h3>

                <p>
                    <i class="bi bi-person-vcard me-1"></i> {{ new Date().getFullYear() - datas.about.informations.birth }} ans <br />
                    <i class="bi bi-geo-alt me-1"></i> {{ datas.about.informations.location }} <br />
                    <i class="bi bi-envelope me-1"></i> {{ datas.about.mail }} <br />
                    <i class="bi bi-linkedin me-1"></i> <a :href="datas.about.linkedin" style="color:inherit;text-decoration:none;">{{ datas.about.name }}</a> <br/>
                    <i class="bi bi-globe me-1"></i> <a :href="'https://'+datas.about.web" style="color:inherit;text-decoration:none;">{{ datas.about.web }}</a>
                </p>


                <h3>Formations</h3>

                <p v-for="course in datas.courses">
                    <b>{{ course.name }}</b><br />
                    <span class="">{{ course.level }}</span><br />
                    <span class="">{{ course.to }} - {{ course.location}}</span>
                </p>


                <h3>Centres d'intérêt</h3>
                <p>
                    <template v-for="interest in datas.personal.interests">
                        <i class=" bi me-2" :class="interest.icon" ></i>
                        <span class=''>{{ interest.name }}</span>
                        <br />
                    </template>
                </p>

                <h3>Langues</h3>

                <p>
                    <span v-for="lang in datas.personal.languages">
                        <b class=''>{{ lang.lang }} : </b>
                        <span class=''>{{ lang.level }}</span><br />
                    </span>
                </p>





            </div>

            <div class='text-white' style="font-size:0.8em;margin:0.5cm;">
                Généré le {{ $dayjs().format('DD/MM/YYYY') }} depuis <a class='text-decoration-none text-success' :href="datas.about.url_web">{{ datas.about.url_sheet }}</a>.
            </div>



        </div>

        <div class="body" style="width:14.5cm;margin-left:0.5cm;margin-right:0.5cm;" >

            <div class="header bg-secondary text-center" style="padding:0.3cm;">
                <h1 class="m-0 p-0 text-primary" style="font-size:3em;">{{ datas.about.name }}</h1>
                <h2 class="m-0 p-0 text-secondary" style="font-size:2em;">{{ datas.about.functions[0] }}</h2>
            </div>

            <div>

                <h3>À propos</h3>

                <p style="text-align:justify;">
                    {{ datas.about.introduction1 }}
                    {{ datas.about.introduction2 }}
                    {{ datas.about.introduction3 }}
                </p>

                <h3>Compétences</h3>

                <div class="d-flex flex-wrap">
                    <p style="margin-top:0cm;margin-bottom:0.3cm;" :style="{ width : ['5.5cm', '4cm', '4cm', '5.5cm', '6.75cm'][skillIdx]}" class="" v-for="(skill, skillIdx) in datas.skills">

<!--                        <b :class="'text-'+skill.class">{{ skill.title }}</b>-->
                        <b class="text-primary">{{ skill.title }}</b>

                        <div class="">
                            <div v-for="subskill in skill.subskills" class="d-flex">
                                <div style="width:0.8cm;">
                                    <i :class="[subskill.icon]" class=""></i>
                                </div>
                                <div>
                                    {{ subskill.label }}
                                </div>
                            </div>
                        </div>
                    </p>
                </div>

                <h3>Expériences</h3>

                <div class="" style="margin-bottom:0.3cm;" v-for="(job, jobIdx) in datas.career">

                    <div class="d-flex">
                        <div class="text-center" style="width:1.5cm;">
                            <img :src="job.organization.logo" style="width:1cm; height:1cm;" />
                        </div>
                        <div class="flex-grow-1">
                            <p class="m-0 p-0">
                                <b class='text-primary m-0 p-0'>{{ job.organization.name }}</b>
                                <br />
                                <span class='text-muted m-0 p-0' style="font-size:0.9em;">
                                    {{ job.organization.type != null ? [job.organization.type, job.organization.location].join(' - ') : job.organization.location }}
                                </span>
                            </p>
                        </div>
                    </div>

                    <p v-for="mission in job.missions" class="d-flex m-0 p-0">

                        <div style="width:1.5cm;">&nbsp;</div>
                        <div class="flex-grow-1">•  {{ mission.label }}</div>
                        <div class="text-primary">{{ showPeriod(mission.from, mission.to) }}</div>

                    </p>


                </div>

            </div>


        </div>




    </div>


</template>

<script>

export default {
    name: 'Sheet',
    mounted : function() {
    },
    methods : {
        showPeriod : function(from, to) {
            let fromDate = this.$dayjs([from[0], from[1], 1]);
            let toDate = to == null ? null : this.$dayjs([to[0], to[1], 1]);

            if (toDate != null)
            {
                return fromDate.format('YYYY') + " - " + toDate.format('YYYY') + " · " +fromDate.from(toDate, true);
            }
            else
            {
                return "Depuis " + fromDate.format('YYYY') + " · " + fromDate.fromNow(true);
            }
        },
        askPrint : function() {
            window.print();
        }
    },
    computed : {
    }
}
</script>

<style scoped>
.A4
{
    font-size:0.37cm;
	line-height:0.4cm;

    background: white;
	display: block;
	margin: 0 auto;
	margin-top: 0.5cm;
	margin-bottom: 0.5cm;
	box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
	width: 21cm;
	height: 29.6cm;

    break-after: page;
}

.sidebar h3 {
    color:var(--bs-gray-200);
    font-size:1.2em !important;
    margin:0px;
    margin-top:1cm;
    padding-bottom:0.15cm;
    margin-bottom:0.15cm;
    border-bottom: 1px solid var(--bs-gray-200);
}

.sidebar p {
    color:var(--bs-gray-200);
    font-size:0.9em;
    line-height:1.5em;
    font-weight:100;
}

.body h3 {
    color:var(--bs-primary);
    font-size:1.2em !important;
    margin:0px;
    margin-top:0.3cm;
    padding-bottom:0.15cm;
    margin-bottom:0.15cm;
    border-bottom: 1px solid var(--bs-primary);
}

.body p {
    color:var(--bs-gray-800);
    font-size:1em;
    line-height:1.5em;
}

@media print
{
	body, .A4
	{
		margin: 0;
		box-shadow: 0;
		size: auto;
		margin: 0mm;
		-webkit-print-color-adjust: exact;
	}

	a[href]:after {
		content: none !important;
	}

	b
	{
		font-weight:700 !important;
	}

	* {
		page-break-after:avoid;
	}
}
@page
{
	size: auto;
	margin: 0mm;
}

@media only screen and (max-width: 1100px) {
    .A4
    {
        overflow:scroll;
        margin:50px !important;
    }
}
</style>
